export const SNOWPACK_PUBLIC_CLIENT_ID = "c87c1f7cefb14d489646bcd19c02566b";
export const SNOWPACK_PUBLIC_API_URL = "https://jrqa1648cb.execute-api.eu-central-1.amazonaws.com/prod";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;